<template>
  <div class="SearchValue">
    <vue-good-table
        ref="searchValue"
        :columns="columns"
        :rows="rows"
        :group-options="{
          enabled: true
        }"
        max-height="200px"
        :fixed-header="false"
        styleClass="vgt-table condensed"
    >
    </vue-good-table>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';

export default {
  name: 'SearchValue',
  props: ['searchValue'],
  components: {
    VueGoodTable
  },
  computed: {
    rows() {
      let result = []
      for (let [key, value] of Object.entries(this.searchValue)) {
        let children = []
        for (let [subKey, subValue] of Object.entries(value)) {
          if (subValue != null && subValue != '')
            children.push({'name': subKey, 'value': subValue})
        }
        if (children.length > 0)
          result.push({'name': key, 'children': children})
      }
      return result
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'Name',
          field: 'name',
          type: 'text',
        },
        {
          label: 'Value',
          field: 'value',
          type: 'text',
        },
      ],
    }
  },
};
</script>

<style scoped lang="scss">

thead th {
  display: none;
  max-height: 0;
}

body {
    //font-weight: 300;
    line-height: 8px;
}

</style>